import { useCallback } from 'react'

import { useDispatch } from 'react-redux'

import { TrackCustomiseButtonClicked } from '@features/recipe-tile/src/model/context/useTracking'

import { actionTypes } from 'actions/actionTypes'

type TrackEventArguments = Parameters<TrackCustomiseButtonClicked>[0]

export const useTracking = () => {
  const dispatch = useDispatch()

  const trackEvent = useCallback(
    (trackingData: TrackEventArguments) => {
      dispatch({
        type: actionTypes.TRACKING,
        trackingData,
      })
    },
    [dispatch],
  )

  const trackCustomiseButtonClicked: TrackCustomiseButtonClicked = useCallback(
    ({ actionType, elementName, recipeId, menuId, orderId }) =>
      trackEvent({
        actionType,
        elementName,
        recipeId,
        menuId,
        orderId,
      }),
    [trackEvent],
  )

  return {
    trackCustomiseButtonClicked,
  }
}
